import { ApolloQueryResult } from '@apollo/client';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IScheduledReport } from 'src/content/main/CustomReport/components/TableScheduledReport';
import { TSocialMedia } from 'src/models/general';
import { ICuratedStreamReport } from 'src/services/useCuratedStreamReportService';

interface IStreamCardProps {
  id: string;
  name: string;
  date: string;
  content: string;
  sentiment: 'positive' | 'negative' | 'neutral';
  link?: string;
  profileImage?: string;
  engagement?: number;
  view?: number;
  followers?: number;
  source?: TSocialMedia;
}

export interface IRowStreamResponse {
  result: Array<IStreamCardProps>;
  page: number;
  limit: number;
  totalRows: number;
  totalPages: number;
}

interface IState {
  // curatedStreamReportList: ApolloQueryResult<ICuratedStreamReportResponse>;
  selectedCuratedStreamReport: ICuratedStreamReport | null;
  streamSosmedList: ApolloQueryResult<IRowStreamResponse>;
  streamSelectedList: IStreamCardProps[];
}

const dataRow = {
  limit: 25,
  page: 1,
  totalRows: 4065,
  totalPages: 163,
  result: [
    {
      content:
        'Terkait Kasus Maybank.\nKomisi III DPR minta aparat penegak hukum untuk usut tuntas tindak pidana perbankan. \n\nPanas Pantai\nKepala Sekolah https://t.co/hRrzAIkMWg',
      engagement: 0,
      from: 'nunutNgiyub',
      view: 4,
      timestamp: '2025-10-15T09:33:34.000Z',
      specificResourceType: 'twitter',
      source: 'twitter',
      link: 'https://twitter.com/nunutNgiyub/status/1978393806295687577',
      profileImage:
        'https://pbs.twimg.com/profile_images/1911222601608826880/5IB88Pta_normal.jpg'
    },
    {
      content:
        '@pepperturner @TheFuturizts Maybank also can with charges.. can look online for the charges fee.. but the price is still low compared to PG',
      engagement: 0,
      from: 'paaain01',
      view: null,
      timestamp: '2025-10-15T09:31:11.000Z',
      specificResourceType: 'twitter',
      source: 'twitter',
      link: 'https://twitter.com/paaain01/status/1978393206984249722',
      profileImage:
        'https://pbs.twimg.com/profile_images/1091038501062103040/M9dcClXq_normal.jpg'
    },
    {
      content:
        '@MyMaybank Hi Maybank. Can i ask about Etiqa Takaful related questions? Let me know. Thanks',
      engagement: 1,
      from: 'ifaaaaa313',
      view: 4,
      timestamp: '2025-10-15T09:18:49.000Z',
      specificResourceType: 'twitter',
      source: 'twitter',
      link: 'https://twitter.com/ifaaaaa313/status/1978390092122091551',
      profileImage:
        'https://pbs.twimg.com/profile_images/1927370627389825024/a77Dv-NR_normal.jpg'
    },
    {
      content:
        '@DiDyaLiLeeya @Aemer_ @PencintaGegirl @Acadhakim @MyMaybank Boleh tau mcm mna nk buat?',
      engagement: 0,
      from: 'nuaq97_',
      view: 4,
      timestamp: '2025-10-15T08:23:22.000Z',
      specificResourceType: 'twitter',
      source: 'twitter',
      link: 'https://twitter.com/nuaq97_/status/1978376136653513089',
      profileImage:
        'https://pbs.twimg.com/profile_images/1908760089529597952/e6u35db4_normal.jpg'
    },
    {
      content: 'yay dah dapat kad maybank design baru tu 😍',
      engagement: 0,
      from: 'wonuaewin',
      view: 11,
      timestamp: '2025-10-15T08:07:28.000Z',
      specificResourceType: 'twitter',
      source: 'twitter',
      link: 'https://twitter.com/wonuaewin/status/1978372135035752765',
      profileImage:
        'https://pbs.twimg.com/profile_images/1973587040676798464/apeRG1oU_normal.jpg'
    },
    {
      content:
        'NUBE PKP PERKUKUH SOLIDARITI MELALUI LAWATAN ZON KE MAYBANK CAWANGAN JELUTONG, PULAU PINANG\n\nRead More@\nhttps://t.co/zaADLU27Bf https://t.co/KPzIPQD5oT',
      engagement: 0,
      from: 'NUBE_Malaysia',
      view: 17,
      timestamp: '2025-10-15T08:03:24.000Z',
      specificResourceType: 'twitter',
      source: 'twitter',
      link: 'https://twitter.com/NUBE_Malaysia/status/1978371113789845633',
      profileImage:
        'https://pbs.twimg.com/profile_images/1120536684184199168/bpKYemLn_normal.png'
    },
    {
      content:
        'Tanggapan Lanjutan perihal “Pengajuan Kartu Kredit Maybank Ditolak dengan Alasan Ada Tunggakan Kartu Kredit Danamon” https://t.co/WFaKRM3ls6',
      engagement: 0,
      from: 'MediaKonsumenID',
      view: 30,
      timestamp: '2025-10-15T07:56:50.000Z',
      specificResourceType: 'twitter',
      source: 'twitter',
      link: 'https://twitter.com/MediaKonsumenID/status/1978369460072226912',
      profileImage:
        'https://pbs.twimg.com/profile_images/632629573335683073/SpL96WeN_normal.jpg'
    },
    {
      content:
        '@Acadhakim @MyMaybank Me looking at my cherry design card and sighs',
      engagement: 0,
      from: 'airasakura_',
      view: 4,
      timestamp: '2025-10-15T07:56:03.000Z',
      specificResourceType: 'twitter',
      source: 'twitter',
      link: 'https://twitter.com/airasakura_/status/1978369263971791157',
      profileImage:
        'https://pbs.twimg.com/profile_images/1952328085619269632/qczMfsah_normal.jpg'
    },
    {
      content:
        'Hi @MyMaybank , wanna ask why i cant add my debit card into Samsung Wallet, it says issue with card issuer.',
      engagement: 1,
      from: '_bellapie_',
      view: 11,
      timestamp: '2025-10-15T07:52:16.000Z',
      specificResourceType: 'twitter',
      source: 'twitter',
      link: 'https://twitter.com/_bellapie_/status/1978368313571856453',
      profileImage:
        'https://pbs.twimg.com/profile_images/1955272749783629824/AdVeV25Z_normal.jpg'
    },
    {
      content: '@Acadhakim @MyMaybank ini indonesia atau buken',
      engagement: 0,
      from: 'ahmad_allvin',
      view: 24,
      timestamp: '2025-10-15T07:43:19.000Z',
      specificResourceType: 'twitter',
      source: 'twitter',
      link: 'https://twitter.com/ahmad_allvin/status/1978366061117399298',
      profileImage:
        'https://pbs.twimg.com/profile_images/1923229401254330369/OT5i2QdO_normal.jpg'
    },
    {
      content:
        '@DayatZam @TheVenusDarling kalau pandai wrap sticker pun ok. sbb ade report kata quality image yg maybank printkan, tak berapa bagus. kene cek dpi ppi image file.',
      engagement: 1,
      from: 'duraNOTace',
      view: 387,
      timestamp: '2025-10-15T07:37:46.000Z',
      specificResourceType: 'twitter',
      source: 'twitter',
      link: 'https://twitter.com/duraNOTace/status/1978364662157549675',
      profileImage:
        'https://pbs.twimg.com/profile_images/1806350722038132736/7kALLyF9_normal.jpg'
    },
    {
      content:
        '✅ Bantu kami sebarkan kebaikan Al-quran seluruh alam. Semoga usaha ini juga dikira sebagai dakwah\n\n✅ Yuran kelas mengaji seikhlas hati tanda anda menyokong usaha kami\n\nMaybank\nKMP Academy Sdn Bhd\n562021653343\n\nKredit KMP ACADEMY ✨',
      engagement: 0,
      from: 'arrogant8_mrs',
      view: 16,
      timestamp: '2025-10-15T06:49:03.000Z',
      specificResourceType: 'twitter',
      source: 'twitter',
      link: 'https://twitter.com/arrogant8_mrs/status/1978352401380716625',
      profileImage:
        'https://pbs.twimg.com/profile_images/1712273398267850752/iU1fma0__normal.jpg'
    },
    {
      content:
        'Sumagot naman po kayo sa tawag or email please!!! Doble po yung repricing nyo from 5.88% to 11% tapos wala kayong documents!!!!',
      engagement: 0,
      from: '',
      view: null,
      timestamp: '2025-10-15T06:42:05.000Z',
      specificResourceType: 'facebook',
      source: 'facebook',
      link: 'https://facebook.com/168151513217686_1138052578435511_1760510525000_08ef96b5c7b33d44cf8560659d66f09ea560c07b4ed6f86929ffda966f639ff1',
      profileImage: null
    },
    {
      content:
        'Sumagot naman po kayo sa tawag or email please!!! Doble po yung repricing nyo from 5.88% to 11% tapos wala kayong documents!!!!',
      engagement: 0,
      from: '',
      view: null,
      timestamp: '2025-10-15T06:41:59.000Z',
      specificResourceType: 'facebook',
      source: 'facebook',
      link: 'https://facebook.com/168151513217686_1138917961682306_1760510519000_08ef96b5c7b33d44cf8560659d66f09ea560c07b4ed6f86929ffda966f639ff1',
      profileImage: null
    },
    {
      content:
        'dia org gelak2 sakan kita yg blik kerja teruk hadap jem , buat highway untuk elak jem dia gi tutup pulak',
      engagement: 0,
      from: '',
      view: null,
      timestamp: '2025-10-15T06:26:17.000Z',
      specificResourceType: 'facebook',
      source: 'facebook',
      link: 'https://facebook.com/159407740862874_1255757786590647_1760509577000_ebfc0de93042e101db8341dd3c835cfb41fcc381844a5c9c998904c9994f34fe',
      profileImage: null
    },
    {
      content:
        'Hello @MyMaybank I cant register my new maybank2u application on pc or smartphone. Please advise, thanks. https://t.co/AdcKrb7vnT',
      engagement: 1,
      from: 'AMINULSWATFADZR',
      view: 5,
      timestamp: '2025-10-15T06:18:17.000Z',
      specificResourceType: 'twitter',
      source: 'twitter',
      link: 'https://twitter.com/AMINULSWATFADZR/status/1978344660012531855',
      profileImage:
        'https://pbs.twimg.com/profile_images/1525478715840294914/CIYILM0U_normal.jpg'
    },
    {
      content: '@MyMaybank @minskie_ Boleh tukar online ke? Tak perlu ke bank?',
      engagement: 0,
      from: 'thirtyoneyea',
      view: 16,
      timestamp: '2025-10-15T06:15:15.000Z',
      specificResourceType: 'twitter',
      source: 'twitter',
      link: 'https://twitter.com/thirtyoneyea/status/1978343896422789585',
      profileImage:
        'https://pbs.twimg.com/profile_images/1977311680771338240/uDn17Bg__normal.jpg'
    },
    {
      content: '@Acadhakim @MyMaybank kelebihan mohon online ke?',
      engagement: 0,
      from: 'IamSya_1125',
      view: 15,
      timestamp: '2025-10-15T06:09:26.000Z',
      specificResourceType: 'twitter',
      source: 'twitter',
      link: 'https://twitter.com/IamSya_1125/status/1978342432963002804',
      profileImage:
        'https://pbs.twimg.com/profile_images/1691332534066667521/ma3DlPgS_normal.jpg'
    },
    {
      content:
        '@itshazmi_ @adobubble @Acadhakim @MyMaybank Tu lah kalau dekat memang sah sampai 😏',
      engagement: 0,
      from: 'DocBerbakat84',
      view: 23,
      timestamp: '2025-10-15T06:07:47.000Z',
      specificResourceType: 'twitter',
      source: 'twitter',
      link: 'https://twitter.com/DocBerbakat84/status/1978342019207434603',
      profileImage:
        'https://pbs.twimg.com/profile_images/886134575587483649/sOLlKw8e_normal.jpg'
    },
    {
      content:
        'Setiap ringgit anda hulurkan dapat membantu lebih ramai rakan komuniti mengetahui status mereka\n\nBersama kita berganding bahu demi mengakhiri AIDS 2030 💪🏻\n\nNo Akaun : 5144 7771 2112\nBank : Malayan Banking Berhad (MAYBANK)\nNama Akaun : Kuala Lumpur AIDS Support Services Society https://t.co/rFazQj3OlJ',
      engagement: 0,
      from: 'klass_my',
      view: 31,
      timestamp: '2025-10-15T05:52:03.000Z',
      specificResourceType: 'twitter',
      source: 'twitter',
      link: 'https://twitter.com/klass_my/status/1978338057251094845',
      profileImage:
        'https://pbs.twimg.com/profile_images/1730400707998892032/LnzAUAQP_normal.jpg'
    },
    {
      content:
        '@DocBerbakat84 @adobubble @Acadhakim @MyMaybank Try klcc branch',
      engagement: 1,
      from: 'itshazmi_',
      view: 31,
      timestamp: '2025-10-15T05:51:46.000Z',
      specificResourceType: 'twitter',
      source: 'twitter',
      link: 'https://twitter.com/itshazmi_/status/1978337988074516585',
      profileImage:
        'https://pbs.twimg.com/profile_images/1978323279690752000/ft-Sldlv_normal.jpg'
    },
    {
      content:
        '@adobubble @itshazmi_ @Acadhakim @MyMaybank Hey @MyMaybank 3 branches and it is not available. Fix your comm',
      engagement: 1,
      from: 'DocBerbakat84',
      view: 33,
      timestamp: '2025-10-15T05:49:42.000Z',
      specificResourceType: 'twitter',
      source: 'twitter',
      link: 'https://twitter.com/DocBerbakat84/status/1978337466995106160',
      profileImage:
        'https://pbs.twimg.com/profile_images/886134575587483649/sOLlKw8e_normal.jpg'
    },
    {
      content:
        'siang open gestun allo bank credinex livin jenius bca cimb paylater yup honest tokopedia card cc kartu kredit saldo masih avail ya via scan qr, jadi langsung  transfer gaperlu co barang instann🫶 #zonauang #zonaba',
      engagement: 0,
      from: 'YONGIEDELIGHT',
      view: 145,
      timestamp: '2025-10-15T05:45:56.000Z',
      specificResourceType: 'twitter',
      source: 'twitter',
      link: 'https://twitter.com/YONGIEDELIGHT/status/1978336520055447560',
      profileImage:
        'https://pbs.twimg.com/profile_images/1863546913053888512/3UcXs-I9_normal.jpg'
    },
    {
      content:
        "loveutomoon's china bank transfer 🇨🇳\n\n✩ rmb x 8.4 no other fee (peso to rmb)\n✩ same day process \n\ntg: takojieun (fast)\n🏷️ ph china bank transfer kpop alipay cimb gcash bpi gotyme seabank php to rmb peso to rmb",
      engagement: 0,
      from: 'loveutomoon',
      view: 25,
      timestamp: '2025-10-15T05:39:46.000Z',
      specificResourceType: 'twitter',
      source: 'twitter',
      link: 'https://twitter.com/loveutomoon/status/1978334967768715759',
      profileImage:
        'https://pbs.twimg.com/profile_images/1974092363095289857/ewIqmkpj_normal.jpg'
    },
    {
      content:
        "loveutomoon's NEW RATE thailand bank transfer 🇹🇭 \n\n✩ baht x 1.87\n✩ any thailand bank \n✩ same day process \n\ntg: takojieun (fast)\n🏷️ ph thailand bank transfer gcash cimb bpi gotyme seabank kpop peso to baht php to baht thai bank th bank",
      engagement: 0,
      from: 'loveutomoon',
      view: 18,
      timestamp: '2025-10-15T05:39:00.000Z',
      specificResourceType: 'twitter',
      source: 'twitter',
      link: 'https://twitter.com/loveutomoon/status/1978334776214855803',
      profileImage:
        'https://pbs.twimg.com/profile_images/1974092363095289857/ewIqmkpj_normal.jpg'
    }
  ]
};

export const dataDummy: IScheduledReport[] = [
  {
    id: '2a9f0b19-3f25-4b9d-8a62-8a1c3f7bb4b2',
    name: 'Weekly Sales Report',
    source: 'Object Group',
    deliveryFrequency: 'Weekly',
    lastDelivery: '2025-10-08 09:00',
    nextDelivery: '2025-10-15 09:00',
    dataSource: ['Internal Data Warehouse', 'Sales Database'],
    recipients: ['marketing@company.com', 'sales@company.com']
  },
  {
    id: '7b2e5d5e-8b24-4b8c-9b0c-6e1e3e4e59ab',
    name: 'Daily Customer Support Summary',
    source: 'Object',
    deliveryFrequency: 'Daily',
    lastDelivery: '2025-10-09 06:00',
    nextDelivery: '2025-10-10 06:00',
    dataSource: ['Customer Support DB', 'Feedback API'],
    recipients: ['support@company.com', 'qa@company.com']
  },
  {
    id: 'e8b3a1d2-5b76-4c99-90e4-9c2a8d3f4c11',
    name: 'Monthly Performance Analytics',
    source: 'Online Media',
    deliveryFrequency: 'Monthly',
    lastDelivery: '2025-10-01 10:30',
    nextDelivery: '2025-11-01 10:30',
    dataSource: ['Google Cloud Storage', 'BigQuery Dataset'],
    recipients: ['ceo@company.com', 'data.team@company.com']
  },
  {
    id: '4d7c5f66-b8b3-4ad9-9e6b-23df12a9c85d',
    name: 'Quarterly Financial Report',
    source: 'Broadcast & Print Media',
    deliveryFrequency: 'Quarterly',
    lastDelivery: '2025-07-01 14:00',
    nextDelivery: '2025-10-01 14:00',
    dataSource: ['Finance System', 'Accounting Ledger'],
    recipients: ['finance@company.com', 'board@company.com']
  },
  {
    id: '8e2a4a1c-3b8d-4e2f-b79b-32a7d2f1e2d9',
    name: 'Social Media Engagement Report',
    source: 'Social Media',
    deliveryFrequency: 'Weekly',
    lastDelivery: '2025-10-07 08:00',
    nextDelivery: '2025-10-14 08:00',
    dataSource: ['Social API', 'TikTok Analytics'],
    recipients: ['social@company.com', 'analytics@company.com']
  }
];

const initialState: IState = {
  // curatedStreamReportList: {
  //   data: {
  //     result: dataDummy,
  //     page: 1,
  //     limit: 10,
  //     totalRows: 0,
  //     totalPages: 0
  //   },
  //   loading: false,
  //   errors: [],
  //   networkStatus: 1,
  //   partial: false
  // },
  streamSosmedList: {
    data: {
      result: [],
      page: 1,
      limit: 10,
      totalRows: 0,
      totalPages: 0
    },
    loading: false,
    errors: [],
    networkStatus: 1,
    partial: false
  },
  streamSelectedList: [
    {
      id: 'awefaewf',
      name: 'Alice Johnson',
      date: '2025-10-20T09:15:00Z',
      content: 'Loving the new update! The design feels cleaner and faster. 🚀',
      sentiment: 'positive',
      link: 'https://twitter.com/alice/status/12345',
      profileImage: 'https://randomuser.me/api/portraits/women/1.jpg',
      engagement: 320,
      view: 1200,
      followers: 5400,
      source: 'twitter'
    },
    {
      id: 'awefrgbtrv',
      name: 'Mark Evans',
      date: '2025-10-19T14:22:00Z',
      content: 'The app keeps crashing on startup. Please fix this ASAP.',
      sentiment: 'negative',
      link: 'https://facebook.com/mark/posts/6789',
      profileImage: 'https://randomuser.me/api/portraits/men/2.jpg',
      engagement: 85,
      view: 500,
      followers: 2100,
      source: 'facebook'
    },
    {
      id: 'awbrtbt',
      name: 'Sarah Kim',
      date: '2025-10-18T22:05:00Z',
      content: 'Interesting insights shared in today’s blog. Worth the read.',
      sentiment: 'neutral',
      link: 'https://medium.com/@sarahk/latest',
      profileImage: 'https://randomuser.me/api/portraits/women/3.jpg',
      engagement: 150,
      view: 900,
      followers: 3200,
      source: 'instagram'
    },
    {
      id: 'aerbttntnt',
      name: 'David Chen',
      date: '2025-10-18T10:42:00Z',
      content: 'Fantastic customer service experience — quick and helpful!',
      sentiment: 'positive',
      profileImage: 'https://randomuser.me/api/portraits/men/4.jpg',
      engagement: 420,
      view: 2100,
      followers: 8700,
      source: 'tiktok'
    },
    {
      id: 'aetntntnt',
      name: 'Maria Lopez',
      date: '2025-10-17T17:30:00Z',
      content: 'Not sure how I feel about the new policy changes.',
      sentiment: 'neutral',
      link: 'https://linkedin.com/in/marialopez',
      profileImage: 'https://randomuser.me/api/portraits/women/5.jpg',
      engagement: 65,
      view: 400,
      followers: 1500,
      source: 'youtube'
    }
  ],
  selectedCuratedStreamReport: null
};

export const customCuratedStramReport = createSlice({
  name: 'custom-curated-stream-report',
  initialState,
  reducers: {
    /**
     * Curated stream report reducer
     */
    // reducerUpdateCuratedStreamReportList: (
    //   state: IState,
    //   action: PayloadAction<ApolloQueryResult<ICuratedStreamReportResponse>>
    // ) => {
    //   state.curatedStreamReportList = action.payload;
    // },
    reducerUpdateSelectedCuratedStreamReport: (
      state: IState,
      action: PayloadAction<ICuratedStreamReport | null>
    ) => {
      state.selectedCuratedStreamReport = action.payload;
    },
    reducerUpdateStreamSelectedList: (
      state: IState,
      action: PayloadAction<IStreamCardProps>
    ) => {
      const streamSelectedList = state.streamSelectedList;
      if (
        streamSelectedList.find((stream) => stream.id === action.payload.id)
      ) {
        state.streamSelectedList = streamSelectedList.filter(
          (stream) => stream.id !== action.payload.id
        );
      } else {
        state.streamSelectedList = [...streamSelectedList, action.payload];
      }
    },
    reducerResetStreamSelectedList: (state: IState) => {
      state.streamSelectedList = [];
    }
  }
});

export const {
  // reducerUpdateCuratedStreamReportList,
  reducerUpdateSelectedCuratedStreamReport,
  reducerUpdateStreamSelectedList,
  reducerResetStreamSelectedList
} = customCuratedStramReport.actions;

export default customCuratedStramReport.reducer;
